export const casteExportColumns = [
	{
		label: 'Caste Name',
		render: c => c?.name || '',
	},
	{
		label: 'Religion',
		render: c => c?.religion?.name || '',
	},
	{
		label: 'Language',
		render: c => (Array.isArray(c?.language) ? c.language.map(l => l.name).join(', ') : ''),
	},
	{
		label: 'Native Place',
		render: c => (Array.isArray(c?.nativeplace) ? c.nativeplace.map(p => p.name).join(', ') : ''),
	},
]
